var ModalState = /** @class */ (function () {
    function ModalState() {
        this.openModal = false;
        this.message = '';
        this.header = '';
    }
    return ModalState;
}());
export { ModalState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/Modal/ModalState.ts
// module id = 592
// module chunks = 50